import { BulkUploadContext } from 'contexts/providers/BulkUploadProvider'
import { useContext } from 'react'

export const useBulkUpload = () => {
  return useContext(BulkUploadContext)
}
